import { render, staticRenderFns } from "./Sdg01.vue?vue&type=template&id=afd41724&scoped=true&"
import script from "./Sdg01.vue?vue&type=script&lang=js&"
export * from "./Sdg01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd41724",
  null
  
)

export default component.exports